import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import "bootstrap-icons/font/bootstrap-icons.css";
import FloatingContactButtons from './components/common/FloatingContactButtons';
import Preloader from './components/common/Preloader';
import PageTransition from './components/PageTransition';
import ScrollToTop from './components/ScrollToTop';

const Home = lazy(() => import('./pages/home/Home'));
const About = lazy(() => import('./pages/about/About'));
const Contact = lazy(() => import('./pages/contact/Contact'));
const WeekendTours = lazy(() => import("./pages/tours/WeekendTours"));
const TourDetails = lazy(() => import("./pages/tours/TourDetails"));
const HomeFaqs = lazy(() => import("./components/faqs/HomeFaqs"));
const ClientTestimonials = lazy(() => import("./components/testimonials/ClientTestimonials"));
const Khajuraho = lazy(() => import("./pages/khajuraho/Khajuraho"));
const KhajurahoDetail = lazy(() => import("./pages/khajuraho/KhajurahoDetail"));
const ScrollRevealGallery = lazy(() => import('./pages/ScrollRevealGallery/ScrollRevealGallery'));
const BusRent = lazy(() => import('./pages/busrent/BusRent'));
const Services = lazy(() => import('./pages/services/Services'));
const PrivacyPolicy = lazy(() => import('./pages/policies/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/policies/TermsConditions'));
const CancellationPolicy = lazy(() => import('./pages/policies/CancellationPolicy'));
const Disclaimer = lazy(() => import('./pages/policies/Disclaimer'));
const TransportCharges = lazy(() => import('./pages/transport/TransportCharges'));
const Hotels = lazy(() => import('./pages/hotels/Hotels'));
const Taxi = lazy(() => import('./pages/taxi/Taxi'));
const NewsMedia = lazy(() => import('./pages/newsMedia/NewsMedia'));
const BlogDetails = lazy(() => import('./pages/newsMedia/BlogDetails'));
const NotFound = lazy(() => import('./pages/notfound/NotFound'));

const App = () => {
  return (
    <>
      <Preloader />
      <Header />
      <ScrollToTop/>
      <PageTransition>
        <Suspense fallback={<Preloader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/tours" element={<WeekendTours />} />
            <Route path="/khajuraho-tour-packages" element={<WeekendTours />} />
            <Route path="/tours/:id" element={<TourDetails />} />
            <Route path="/khajuraho-tour-packages/:id" element={<TourDetails />} />
            <Route path="/faqs" element={<><Helmet><title>FAQs | Khajuraho Routes</title><meta name="description" content="Frequently Asked Questions about Khajuraho tourism and our services." /><link rel="canonical" href="https://khajurahoroutes.com/faqs" /></Helmet><HomeFaqs /></>} />
            <Route path="/testimonials" element={<><Helmet><title>Testimonials | Khajuraho Routes</title><meta name="description" content="Read reviews and testimonials from our happy travelers." /><link rel="canonical" href="https://khajurahoroutes.com/testimonials" /></Helmet><ClientTestimonials /></>} />
            <Route path="/khajuraho" element={<Khajuraho />} />
            <Route path="/khajuraho/:id" element={<KhajurahoDetail />} />
            <Route path="/scroll-gallery" element={<ScrollRevealGallery />} />
            <Route path="/gallery" element={<ScrollRevealGallery />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/taxi" element={<Taxi />} />
            <Route path="/taxi-service" element={<Taxi />} />
            <Route path="/busrent" element={<BusRent />} />
            <Route path="/services" element={<Services />} />
            <Route path="/privacy-policy" element={<><Helmet><title>Privacy Policy | Khajuraho Routes</title><meta name="description" content="Read the privacy policy of Khajuraho Routes - how we collect, use and protect your information for tour bookings in Khajuraho." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/privacy-policy" /></Helmet><PrivacyPolicy /></>} />
            <Route path="/terms-conditions" element={<><Helmet><title>Terms & Conditions | Khajuraho Routes</title><meta name="description" content="Read the terms and conditions for booking Khajuraho tours, taxi and hotel services with Khajuraho Routes." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/terms-conditions" /></Helmet><TermsConditions /></>} />
            <Route path="/cancellation-policy" element={<><Helmet><title>Cancellation Policy | Khajuraho Routes</title><meta name="description" content="Read the cancellation and refund policy for Khajuraho tour packages, taxi and hotel bookings." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/cancellation-policy" /></Helmet><CancellationPolicy /></>} />
            <Route path="/disclaimer" element={<><Helmet><title>Disclaimer | Khajuraho Routes</title><meta name="description" content="Read the disclaimer for travel information, itineraries and services published by Khajuraho Routes." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/disclaimer" /></Helmet><Disclaimer /></>} />
            <Route path="/transport-charges" element={<TransportCharges />} />
            <Route path="/news-media" element={<NewsMedia />} />
            <Route path="/blog" element={<NewsMedia />} />
            <Route path="/news-media/:id" element={<BlogDetails />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </PageTransition>
      <FloatingContactButtons />
      <Footer />
    </>
  );
};

export default App;
